var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    stroke: "#868686",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "message"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M3.66699 19.6504V7.7337C3.66699 6.21492 4.89821 4.9837 6.41699 4.9837H15.5837C17.1024 4.9837 18.3337 6.21492 18.3337 7.7337V13.2337C18.3337 14.7525 17.1024 15.9837 15.5837 15.9837H7.33366L3.66699 19.6504"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M7.33301 8.65041H14.6663"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M7.33301 12.317H12.833"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.5d272d26ec33d38952ccb5bccb541f80.svg";
export { ForwardRef as ReactComponent };